<script>
  export let errors
</script>

<div class="alert alert-danger">
  {#each errors as error}
    <p>{error}</p>
  {/each}
</div>
